export default __webpack_public_path__ + "static/media/lock.fa018267.svg";